import styled from 'styled-components';

export const FooterWrap = styled.footer`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    padding: 3rem 6.25rem;
    background-color: ${({ theme }) => theme.colors['supernova-500']};

    section {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;

        align-items: flex-start;
        width: 100%;
        max-width: 90rem;

        div {
            width: 100%;
            display: flex;
            justify-content: space-between;

            @media (max-width: 768px) {
                flex-direction: column;
                align-items: center;
                gap: 1.3rem;
            }
        }
    }
`;

export const WrapImagesValues = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    /* filter: brightness(0) saturate(100%) invert(0%); */
    min-height: 100%;

    @media (max-width: 768px) {
        flex-direction: row !important;
        justify-content: center !important;

        svg {
            width: 8rem;
            object-fit: cover;
            height: auto;
        }
    }

    &[aria-selected='true'] {
        gap: 0;
        filter: initial;
        align-items: flex-start;

        span {
            color: ${({ theme }) => theme.colors['neutral-900']};
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }

        p {
            color: ${({ theme }) => theme.colors['neutral-900']};
            font-size: 0.655rem;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
    }

    a {
        color: black;
        font-size: 1rem;
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
        cursor: pointer;
        width: fit-content;
        text-decoration: none;
    }
`;

export const WrapValuesText = styled.div`
    display: flex;
    gap: 3rem;

    &[aria-selected='true'] {
        gap: 0.75rem;
        width: fit-content;
        flex-direction: row;
    }
`;

export const Separator = styled.div`
    width: 100%;
    height: 2px;
    background-color: ${({ theme }) => theme.colors['neutral-900']};
`;

export const WrapItensText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    span {
        display: flex;
        align-items: center;
        color: black;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
        cursor: pointer;

        gap: 0.5rem;
    }

    h2 {
        color: ${({ theme }) => theme.colors['neutral-900']};
        font-size: 1rem;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    @media (max-width: 768px) {
        gap: 0.4rem;
    }
`;
